import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: 504,
    },
  },
  headerContainer: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
    },
  },
  description: {
    color: theme.color.greys[60],
    marginTop: 24,
  },
  buttonBox: {
    marginTop: 24,
    width: '100%',
    display: 'flex',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 24,
    },
  },
  warningIcon: {
    color: theme.color.oranges[50],
  },
}), { name: 'ConfirmationDialog', index: StylesIndexInjections.UI_MOLECULES });
